import React from "react";
import Button from "components/form/Button";
import { useTid } from "utils/testid";

interface UpdateButtonsProps {
  isUpdateLoading: boolean;
  isDisabled: boolean;
  onBack: () => void;
  onUpdate: () => Promise<void>;
  show: boolean;
  currentStep: number;
  isUpdatePaymentPlan: boolean;
  isRetryPayment: boolean;
  isFinalPreview: boolean;
  showButtons: boolean;
  initialDisclosureAccept: boolean;
  showFinalDisclosure: boolean;
}

const UpdateButtons: React.FC<UpdateButtonsProps> = ({
  isUpdateLoading,
  isDisabled,
  onBack,
  onUpdate,
  show,
  currentStep,
  isUpdatePaymentPlan,
  isRetryPayment,
  isFinalPreview,
  showButtons,
  initialDisclosureAccept,
  showFinalDisclosure,
}) => {
  const tid = useTid();
  const shouldShowButtons =
    currentStep === 2 &&
    !isUpdatePaymentPlan &&
    !isRetryPayment &&
    !isFinalPreview &&
    showButtons &&
    initialDisclosureAccept &&
    !showFinalDisclosure;

  if (!shouldShowButtons) {
    return null;
  }

  return (
    <div
      className="w-full"
      data-testid={tid("update-plan-footer-actions")}
      aria-label="Update plan actions"
    >
      <div className="absolute bg-white w-full left-0 bottom-0 py-[15px] z-20 border border-t lg:px-10 px-5">
        <div className="w-full lg:flex gap-7">
          <div className="lg:w-[5.2%] md2:w-[5.5%] w-0"></div>
          <div className="w-full flex justify-between gap-5 ">
            <Button
              variant="white"
              text="Back"
              className="lg:!w-40 w-full"
              onClick={onBack}
              data-testid={tid("update-plan-back-button")}
              aria-label="Go back in update plan"
            />

            <Button
              className="lg:!w-40 w-full"
              isLoading={isUpdateLoading}
              text="Update"
              type="button"
              isDisabled={isDisabled}
              onClick={onUpdate}
              data-testid={tid("update-plan-update-button")}
              aria-label="Update payment plan"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateButtons;
